import { makeAutoObservable, reaction, runInAction } from "mobx";
import { UserPermissions, UserProfile } from "../models/user";
import { toast } from "react-toastify";
import { router } from "../router/Routes";
import jwt_decode from "jwt-decode";
import agent from "../api/agent";
import { store } from "./store";
import {
  ICurrentStore,
  ICurrentStoreProduct,
  IVendor,
} from "../models/general";

export default class CommonStore {
  loadingInitial = "";
  storeList: IVendor[] = [];
  currentStore: ICurrentStore | null = null;
  currentStoreProductList: ICurrentStoreProduct[] = [];
  GetItem = (title: string) => {
    try {
      const data = window.localStorage.getItem(title);
      return agent.decryptResponse(data);
    } catch {
      return null;
    }
  };
  token: string | null = this.GetItem("jwt");
  reftoken: string | null = this.GetItem("refjwt");
  appLoaded = false;
  loggedInUser: UserProfile | null = this.GetItem("user")!;

  constructor() {
    makeAutoObservable(this);

    reaction(
      () => this.token,
      (token) => {
        if (token) {
          localStorage.setItem("jwt", agent.encryptRequest(token));
        } else {
          localStorage.removeItem("jwt");
        }
      }
    );
    reaction(
      () => this.reftoken,
      (reftoken) => {
        if (reftoken) {
          localStorage.setItem("refjwt", agent.encryptRequest(reftoken));
        } else {
          localStorage.removeItem("refjwt");
        }
      }
    );

    reaction(
      () => this.loggedInUser,
      (loggedInUser) => {
        if (loggedInUser) {
          window.localStorage.setItem(
            "user",
            agent.encryptRequest(loggedInUser)
          );
        } else {
          window.localStorage.removeItem("user");
        }
      }
    );
  }
  get isLoggedIn() {
    return !!this.loggedInUser;
  }

  remainingTime() {
    try {
      const accessToken = localStorage.getItem("jwt");
      if (accessToken) {
        // Simulate exp claim with fixed 5 mins lifetime
        const fakeExp = Math.floor((Date.now() + 5 * 60 * 1000) / 1000); 
        let tokenExpDate = new Date(fakeExp * 1000).getTime() - Date.now();
        // const decryptedToken = agent.decryptResponse(accessToken)
        // const decoded = JSON.parse(JSON.stringify(jwt_decode(decryptedToken)));
        // let tokenExpDate = new Date(decoded.exp * 1000).getTime() - Date.now();
        // console.log(tokenExpDate, "expiration time")
        return tokenExpDate;
      } else return 0;
    } catch (error) {
      return 0;
    }
  }

  setToken = (token: string | null) => {
    this.token = token;
  };
  setRefToken = (reftoken: string | null) => {
    this.reftoken = reftoken;
  };
  setLoggedInUser = (user: any | null) => {
    this.loggedInUser = user;
  };
  setAppLoaded = () => {
    this.appLoaded = true;
  };

  getCallBackResponse = async (request: string) => {
    try {
      const response = await agent.Orders.getCallBackResponse(request);

      return response;
    } catch (error) {
      // this.setStatus("idle");
      throw error;
    }
  };
  tokenRefresh = async () => {
    try {
      const jwt = window.localStorage.getItem("jwt")
      if (this.loggedInUser && this.loggedInUser.refresh_token && jwt) {
        const payload = {
          userId: this.loggedInUser.userId,
          refreshToken: this.token,
          email : this.loggedInUser.email
        };
        // console.log(payload);
        const response = await agent.Account.refreshToken(payload);
        runInAction(() => {
          if (response.isSuccessful) {
            const { accessToken } = response.data;
            this.setToken(accessToken);
            window.localStorage.setItem(
              "jwt",
              agent.encryptRequest(accessToken)
            );
          } else {
            this.clearLocalStorage();
            toast.info("Your session has expired, please login again");
          }
        });
      }else {
        this.clearLocalStorage();
        toast.info("Your session has expired, please login again");
      }
    } catch (error) {
      // this.setStatus("idle");
      throw error;
    }
  };
  getVendors = async () => {
    this.loadingInitial = "loading";
    try {
      const response = await agent.Activities.getVendorStores();
      if (response.isSuccessful)
        runInAction(() => {
          this.storeList = response.data;
        });

      this.loadingInitial = "";
      // console.log(response);
      return response;
    } catch (error) {
      this.loadingInitial = "";
      var error1 = "Error fetching data";
      throw error1;
    }
  };
  fetchVendorStore = async (id: string) => {
    this.loadingInitial = "loading";
    try {
      const response = await agent.Activities.getVendorStore(id);
      // console.log("response", response);
      if (response.isSuccessful)
        runInAction(() => {
          this.currentStore = response.data;
          this.currentStoreProductList = response.data.product;
        });
      else {
        toast.info(response.responseMessage);
        router.navigate("/vendors");
      }
      this.loadingInitial = "";
      return response;
    } catch (error) {
      this.loadingInitial = "";
      var error1 = "Error fetching data";
      throw error1;
    }
  };
  isAuthorized = (creds: UserPermissions) => {
    const loggedInUser = this.loggedInUser;
    if (
      (loggedInUser && loggedInUser[creds]) ||
      (loggedInUser && loggedInUser.roleName === "Owner")
    )
      return true;
    else return false;
  };

  clearLocalStorage() {
    window.localStorage.removeItem("jwt");
    window.localStorage.removeItem("refreshToken");
    window.localStorage.removeItem("mToken");
    window.localStorage.removeItem("user");
    window.localStorage.removeItem("profileStatus");
    this.loggedInUser = null;
    this.token = null;
    router.navigate("/");
    // toast.info("Your session has expired, please login again");
  }
}
